<script lang="ts">
    import { ValidationProvider } from "vee-validate";
    import Vue from 'vue';

    export default Vue.extend({
        name: "CheckboxControl",
        components: {
            ValidationProvider
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            rules: {
                type: [String, Object],
                default: ""
            },
            label: {
                type: String,
                default: ""
            },
            helpText: {
                type: String,
                default: ""
            },
            tooltipText: {
                type: String,
                default: ""
            },
            name: {
                type: String,
                default: ""
            },
            vid: {
                type: String,
                default: undefined
            },
        },
        data() {
            return {
                checkedProxy: false
            }
        },
        computed: {
            checked: {
                get(): boolean {
                    return this.value
                },
                set(val: boolean): void {
                    this.checkedProxy = val
                }
            }
        },
        methods: {
            handleChange() {
                this.$emit('input', this.checkedProxy)
            }
        }
    });
</script>

<style lang="scss" scoped>
</style>

<template>
    <ValidationProvider
        slim
        :rules="rules"
        :name="name || label"
        :vid="vid"
        v-slot="{ errors, classes }" >
        <div class="form-group" :class="classes">
            <label class="checkbox-inline">
                <input type="checkbox" 
                    @change="handleChange" 
                    v-model="checked"
                />{{ label || name }}</label> <!-- checked="value"  -->
            <span v-if="helpText" class="help-block">{{ helpText }}</span><span href="javascript:;" v-if="tooltipText" class="helper-icon" v-bootstrap-tooltip="{ placement: 'top', title: tooltipText}">?</span>
            <span class="help-block" v-if="errors[0]">
                {{ errors[0] }}
            </span>
        </div>
    </ValidationProvider>
</template>
